import {
	BaseError,
} from './BaseError';

export class GetCompanyTransactionsError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
